module.exports = __webpack_public_path__ + "static/media/golf-carousel-480x320.9d56d77e.jpg";